<label for="txtattactments" class="form-label text__custom-label"> {{text|translate}} <span *ngIf="isNecessary">*</span></label>
<input type="file" #fileInput id="listAttactments" accept="{{accept}}" (change)="onFileSelected($event)" hidden [multiple]="isMultiple">
<button type="button" class="choose-file" (click)="fileInput.click()">
  {{'LABEL.CHONFILE'|translate}}
</button>
<span class="e-float-line"></span>

<!-- Hiển thị preview ảnh đã chọn -->
<div class="image-preview" *ngIf="selectedFiles.length > 0">
  <div class="image-container" *ngFor="let file of selectedFiles; let i = index; trackBy: trackByFile">
    <img [src]="getImageUrl(file)" alt="Preview" class="preview-img" (click)="onPreviewClick(file)" />
    <button type="button" class="delete-btn" (click)="removeFile(i)">
      <i class="ti ti-trash"></i> Xóa
    </button>
  </div>
</div>
<span class="errorTxt__custom" *ngIf="errMessage != ''">
    {{ errMessage }}
</span>
